import { ApolloProvider } from '@apollo/client'
import { useWeb3React } from '@web3-react/core'
import { SupportedChainId } from 'constants/chains'
import { clients } from 'graphql/apollo'
import React, { useMemo } from 'react'

export default function Provider({ children }: React.PropsWithChildren) {
  const { chainId } = useWeb3React()
  const client = useMemo(
    //@ts-ignore
    () => clients[chainId ?? SupportedChainId.ZK_SYNC] ?? clients[SupportedChainId.ZK_SYNC],
    [chainId]
  )
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
